import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';

import heroBanner from "./components/HeroBanner.vue";
import propsBanner from "./components/PropsBanner.vue";
import features from "./components/Features.vue";
import downloadApp from "./components/DownloadApp.vue";
import reviews from "./components/Reviews.vue";
import valueProps from "./components/ValueProps.vue";

sys.fontLibrary.add(icons.regular.faCircleXmark);
sys.fontLibrary.add(icons.solid.faCheck);
sys.fontLibrary.add(icons.solid.faTruckMoving);
sys.fontLibrary.add(icons.solid.faTruckFront);
sys.fontLibrary.add(icons.solid.faCaravan);
sys.fontLibrary.add(icons.solid.faRoad);
sys.fontLibrary.add(icons.solid.faAngleLeft);
sys.fontLibrary.add(icons.solid.faAngleRight);
sys.fontLibrary.add(icons.solid.faMagnifyingGlassLocation);
sys.fontLibrary.add(icons.solid.faClock);
sys.fontLibrary.add(icons.solid.faRankingStar);
sys.fontLibrary.add(icons.solid.faMapLocationDot);
sys.fontLibrary.add(icons.solid.faBullhorn);
sys.fontLibrary.add(icons.solid.faScrewdriverWrench);
sys.fontLibrary.add(icons.solid.faLock);
sys.fontLibrary.add(icons.solid.faCheckCircle);


sys.configure((app) => {
    app.component('hero-banner', heroBanner);
    app.component('props-banner', propsBanner);
    app.component('features', features);
    app.component('download-app', downloadApp);
    app.component('reviews', reviews);
    app.component('value-props', valueProps);
});

sys.initialize();
